// **** Constants **** //

export const MAX_TASK_NAME_CHAR_LENGTH = 255;
export const MAX_TASK_DESCRIPTION_CHAR_LENGTH = 100;
const ADMIN_PATHS_ROOT = '/adminConfiguration';
const TASK_PATH_ROOT = `${ADMIN_PATHS_ROOT}/taskConfiguration`;
const TASK_TAB_ROOT = 'task-config';
const FORM_PATH_ROOT = `${ADMIN_PATHS_ROOT}/restrictionFormConfiguration`;
const FORM_TAB_ROOT = 'form-config';

export const AdminConfigNavConsts = {
  root: ADMIN_PATHS_ROOT,
  Site: {
    TAB: 'site-config',
    PATH: `${ADMIN_PATHS_ROOT}/siteConfiguration`,
  },
  Task: {
    root: {
      TAB: TASK_TAB_ROOT,
      PATH: TASK_PATH_ROOT,
    },
    Tasks: {
      TAB: `${TASK_TAB_ROOT}-task-table`,
      PATH: `${TASK_PATH_ROOT}/task`,
    },
    TaskGroups: {
      TAB: `${TASK_TAB_ROOT}-task-group-table`,
      PATH: `${TASK_PATH_ROOT}/taskGroup`,
    },
  },
  Form: {
    root: {
      TAB: FORM_TAB_ROOT,
      PATH: FORM_PATH_ROOT,
    },
    Table: {
      TAB: `${FORM_TAB_ROOT}-table`,
      PATH: `${FORM_PATH_ROOT}/forms`,
    },
    Edit: {
      TAB: `${FORM_TAB_ROOT}-edit`,
      PATH: `${FORM_PATH_ROOT}/edit`,
    },
  },
  Modification: {
    TAB: 'modification-config',
    PATH: `${ADMIN_PATHS_ROOT}/jobModificationConfiguration`,
  },
} as const;

// "Parent" Tabs
const AdminConfigTabMapRoot: ReadonlyMap<string, string> = new Map([
  // Tabs to Path
  [AdminConfigNavConsts.Site.TAB, AdminConfigNavConsts.Site.PATH],
  [AdminConfigNavConsts.Task.root.TAB, AdminConfigNavConsts.Task.root.PATH],
  [AdminConfigNavConsts.Form.root.TAB, AdminConfigNavConsts.Form.root.PATH],
  [AdminConfigNavConsts.Modification.TAB, AdminConfigNavConsts.Modification.PATH],
  // Paths to Tabs
  [AdminConfigNavConsts.Site.PATH, AdminConfigNavConsts.Site.TAB],
  [AdminConfigNavConsts.Task.root.PATH, AdminConfigNavConsts.Task.root.TAB],
  [AdminConfigNavConsts.Task.Tasks.PATH, AdminConfigNavConsts.Task.root.TAB],
  [AdminConfigNavConsts.Task.TaskGroups.PATH, AdminConfigNavConsts.Task.root.TAB],
  [AdminConfigNavConsts.Form.root.PATH, AdminConfigNavConsts.Form.root.TAB],
  [AdminConfigNavConsts.Form.Table.PATH, AdminConfigNavConsts.Form.root.TAB],
  [AdminConfigNavConsts.Form.Edit.PATH, AdminConfigNavConsts.Form.root.TAB],
  [AdminConfigNavConsts.Modification.PATH, AdminConfigNavConsts.Modification.TAB],
]);

// "Task" Tabs
const TaskMapRoot: ReadonlyMap<string, string> = new Map([
  [AdminConfigNavConsts.Task.Tasks.TAB, AdminConfigNavConsts.Task.Tasks.PATH],
  [AdminConfigNavConsts.Task.TaskGroups.TAB, AdminConfigNavConsts.Task.TaskGroups.PATH],
  [AdminConfigNavConsts.Task.Tasks.PATH, AdminConfigNavConsts.Task.Tasks.TAB],
  [AdminConfigNavConsts.Task.TaskGroups.PATH, AdminConfigNavConsts.Task.TaskGroups.TAB],
]);

// "Form" Tabs
const FormMapRoot: ReadonlyMap<string, string> = new Map([
  [AdminConfigNavConsts.Form.Table.TAB, AdminConfigNavConsts.Form.Table.PATH],
  [AdminConfigNavConsts.Form.Edit.TAB, AdminConfigNavConsts.Form.Edit.PATH],
  [AdminConfigNavConsts.Form.Table.PATH, AdminConfigNavConsts.Form.Table.TAB],
  [AdminConfigNavConsts.Form.Edit.PATH, AdminConfigNavConsts.Form.Edit.TAB],
]);

// So we don't constantly have to check for undefined
export const AdminConfigTabMap = {
  get(key: string) {
    return AdminConfigTabMapRoot.get(key) ?? '';
  },
  TaskConfig: {
    get(key: string) {
      return TaskMapRoot.get(key) ?? '';
    },
  },
  FormConfig: {
    get(key: string) {
      return FormMapRoot.get(key) ?? '';
    },
  },
} as const;
